<div class="cross-sell-card-width bl-bg-color--white bl-border bl-border-radius--16 bl-padding--24 bl-text-align--center">
  <div class="cross-sell-card-min-height bl-display--flex bl-flex-direction--column">
    <!-- Cross sell heading and image -->
    <div class="fs-cross-sell-watched bl-display--flex bl-gap--16 bl-margin-bottom--8 bl-align-items--center">
      <dx-product-image
        class="cross-sell-image dx-no-bg-highlight"
        [flowType]="'ola'"
        [mask]="'confetti'"
        [product]="item.loanType"
        [size]="'48px'"
      ></dx-product-image>
      <!-- <ea-svg height="48px" minHeight="48px" minWidth="74px" width="74px" [svgClass]="icon" /> -->
      <div class="bl-display--flex bl-flex-direction--column bl-justify-content--center bl-text-align--left">
        <!-- Cross sell heading -->
        <h3 class="bl-text-style--secondary-text-2 bl-margin--0">{{ item?.displayName }}</h3>
        @if (item?.offerDetails.headline) {
          <p class="bl-text-style--display-6 bl-margin--0">{{ item.offerDetails.headline }}</p>
        }
        @if (item?.offerDetails.subtitle) {
          <p class="bl-text-style--secondary-text-2 bl-margin--0">{{ item.offerDetails.subtitle }}</p>
        }
      </div>
    </div>
    <!-- Cross sell data -->
    <!-- <div class="bl-flex--auto bl-display--flex bl-flex-direction--column bl-justify-content--center"> -->

    <!-- Cross sell terms button and actions-->
    <div class="bl-display--flex bl-align-items--start bl-gap--8">
      <!-- Cross sell expand/collapse button -->
      <button class="bl-button bl-button-tertiary bl-button-small" [class.bl-bg-color--snow-dark]="!isCollapsed" (click)="expandCard()">
        <span class="bl-font-weight--700 bl-font-size--12">
          {{ 'crossSell/expandCardText' | dictionary }}
          <i class="bl-margin-left--8 bl-margin-right--0" [ngClass]="isCollapsed ? 'cu-chevron-down' : 'cu-chevron-up'"></i>
        </span>
      </button>
      <!-- Cross sell actions -->
      <div class="action-button">
        @if (!btnCallbackSuccess) {
          <button
            class="bl-button bl-button-reverse bl-border bl-width--100 bl-button-small"
            [name]="item?.offerDetails.description"
            (click)="acceptOffer()"
          >
            <!-- Update dictionary text here to show apply for non interested -->
            <span class="bl-font-size--12 bl-font-weight--700">
              {{
                item.crossSellOption === 'ExpressInterest'
                  ? ('crossSell/ctaInterested' | dictionary)
                  : ('crossSell/ctaTakeOffer' | dictionary)
              }}
            </span>
          </button>
        }
        @if (btnCallbackSuccess) {
          <span class="bl-font-color--primary bl-margin-x--auto bl-width--100">
            {{ 'crossSell/ctaSuccessText' | dictionary }}
          </span>
        }
      </div>
    </div>
    <!-- Cross sell expandable data -->
    <!-- TODO refactor this section -->
    @if (!isCollapsed) {
      <!-- XSellOfferInfo details block cross sell tiles -->
      <div class="bl-display--flex bl-padding-bottom--8 bl-width--100">
        <div class="bl-font-weight--800 bl-text-align--left"></div>
      </div>
      <!-- When Is Revolving condition is TRUE -->
      @if (item?.offerDetails.isRevolving) {
        <div
          class="bl-display--flex bl-padding-top--8 bl-padding-bottom--8 bl-width--100 bl-border-bottom--solid bl-text-style--secondary-text-1"
        >
          <div class="bl-font-weight--400 bl-text-align--left bl-width--50">
            {{ 'crossSell/requestedCreditText' | dictionary }}
          </div>
          <div class="bl-font-weight--800 bl-text-align--right bl-width--50">
            {{ item?.offerDetails.decisionAmount | currency: 'USD' : 'symbol' : '1.2' }}
          </div>
        </div>
      }
      @if (item?.offerDetails.isRevolving) {
        <div class="bl-display--flex bl-padding-top--8 bl-width--100 bl-text-style--secondary-text-1">
          <div class="bl-font-weight--400 bl-text-align--left bl-width--50">
            {{ 'crossSell/discEstRate' | dictionary }}
          </div>
          <div class="bl-font-weight--800 bl-text-align--right bl-width--50">{{ item?.offerDetails.decisionRate }}% APR</div>
        </div>
      }
      @if (!item?.offerDetails.isRevolving) {
        <div
          class="bl-display--flex bl-padding-bottom--8 bl-padding-top--8 bl-width--100 bl-border-bottom--solid bl-text-style--secondary-text-1"
        >
          <div class="bl-font-weight--400 bl-text-align--left bl-width--75">
            {{ 'crossSell/discEstMonthlyPayment' | dictionary }}
          </div>
          <div class="bl-font-weight--800 bl-text-align--right bl-width--25">
            {{ item?.offerDetails.estimatedPayment | currency: 'USD' : 'symbol' : '1.2' }}
          </div>
        </div>
      }
      @if (!item?.offerDetails.isRevolving) {
        <div
          class="bl-display--flex bl-padding-bottom--8 bl-padding-top--8 bl-width--100 bl-border-bottom--solid bl-text-style--secondary-text-1"
        >
          <div class="bl-font-weight--400 bl-text-align--left bl-width--50">
            {{ 'crossSell/discLoanamount' | dictionary }}
          </div>
          <div class="bl-font-weight--800 bl-text-align--right bl-width--50">
            {{ item?.offerDetails.decisionAmount | currency: 'USD' : 'symbol' : '1.2' }}
          </div>
        </div>
      }
      @if (!item?.offerDetails.isRevolving) {
        <div
          class="bl-display--flex bl-padding-bottom--8 bl-padding-top--8 bl-width--100 bl-border-bottom--solid bl-text-style--secondary-text-1"
        >
          <div class="bl-font-weight--400 bl-text-align--left bl-width--50">
            {{ 'crossSell/discEstRate' | dictionary }}
          </div>
          <div class="bl-font-weight--800 bl-text-align--right bl-width--50">{{ item?.offerDetails.decisionRate }}% APR</div>
        </div>
      }
      @if (!item?.offerDetails.isRevolving && !isCreditCard) {
        <div class="bl-display--flex bl-padding-top--8 bl-width--100 bl-text-style--secondary-text-1">
          <div class="bl-font-weight--400 bl-text-align--left bl-width--50">
            {{ 'crossSell/discTerm' | dictionary }}
          </div>
          @if (item?.offerDetails.decisionTerm) {
            <div class="bl-font-weight--800 bl-text-align--right bl-width--50">{{ item?.offerDetails.decisionTerm }} months</div>
          }
        </div>
      }
      <div class="bl-display--flex bl-margin-bottom--8 bl-padding-top--16 bl-width--100 bl-flex-direction--column bl-font-size--14">
        @if (expirationDate) {
          <div class="bl-text-align--left">
            <span class="bl-text-style--secondary-text-2">Disclosure:</span>
            <span class="bl-text-style--secondary-text-1">
              {{ 'crossSell/offerGoodThru' | dictionary }}{{ expirationDate | date: 'M/d/yy' }}.
            </span>
          </div>
        }
        <div class="bl-font-weight--400 bl-text-align--left bl-padding-left--24">
          <ul>
            @for (stipulation of stipulationList; track stipulation) {
              <li class="cross-sell-stipulation">{{ stipulation }}</li>
            }
          </ul>
        </div>
      </div>
      @if (item?.offerDetails.documentLinkDisplayText && item?.offerDetails.documentLinkDisplayText.length > 0) {
        <div class="bl-font-size--14 bl-font-weight--700 bl-font-color--primary bl-text-align--left">
          @if (item?.offerDetails.docRepID || item?.offerDetails.termsAndConditions || stipulationsShortened) {
            <button (click)="openCrossSellDocModal()">
              <span class="bl-cursor--pointer, bl-text-decoration--underline">{{ item?.offerDetails.documentLinkDisplayText }}</span>
            </button>
          }
        </div>
      }
    }
  </div>
</div>
